var _path, _path2, _g, _g2, _path3, _g3, _g4, _g5, _g6, _g7, _g8, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMainLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 162,
    height: 52,
    viewBox: "0 0 162 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M54.68 43.38C52.9333 43.38 51.28 43.1067 49.72 42.56V39.98C51.48 40.54 53.12 40.82 54.64 40.82C56.1467 40.82 57.2933 40.5067 58.08 39.88C58.8667 39.24 59.26 38.3333 59.26 37.16C59.26 36.16 59.02 35.3933 58.54 34.86C58.06 34.3133 57.32 33.9 56.32 33.62L54.12 33.04C52.4133 32.5733 51.1733 31.8667 50.4 30.92C49.64 29.96 49.26 28.7067 49.26 27.16C49.26 25.9467 49.5533 24.8733 50.14 23.94C50.7267 23.0067 51.5867 22.28 52.72 21.76C53.8667 21.2267 55.24 20.96 56.84 20.96C58.2933 20.96 59.7 21.12 61.06 21.44V24.04C60.34 23.8667 59.66 23.74 59.02 23.66C58.38 23.58 57.6933 23.54 56.96 23.54C55.3333 23.54 54.12 23.8733 53.32 24.54C52.52 25.2067 52.12 26.0667 52.12 27.12C52.12 28.0267 52.3467 28.7467 52.8 29.28C53.2667 29.8 53.9867 30.2 54.96 30.48L57.16 31.08C58.9467 31.56 60.22 32.28 60.98 33.24C61.74 34.2 62.12 35.4733 62.12 37.06C62.12 38.3667 61.82 39.5 61.22 40.46C60.6333 41.4067 59.78 42.1333 58.66 42.64C57.5533 43.1333 56.2267 43.38 54.68 43.38ZM69.8363 43.38C68.0896 43.38 66.4363 43.1067 64.8763 42.56V39.98C66.6363 40.54 68.2763 40.82 69.7963 40.82C71.3029 40.82 72.4496 40.5067 73.2363 39.88C74.0229 39.24 74.4163 38.3333 74.4163 37.16C74.4163 36.16 74.1763 35.3933 73.6963 34.86C73.2163 34.3133 72.4763 33.9 71.4763 33.62L69.2763 33.04C67.5696 32.5733 66.3296 31.8667 65.5563 30.92C64.7963 29.96 64.4163 28.7067 64.4163 27.16C64.4163 25.9467 64.7096 24.8733 65.2963 23.94C65.8829 23.0067 66.7429 22.28 67.8763 21.76C69.0229 21.2267 70.3963 20.96 71.9963 20.96C73.4496 20.96 74.8563 21.12 76.2163 21.44V24.04C75.4963 23.8667 74.8163 23.74 74.1762 23.66C73.5363 23.58 72.8496 23.54 72.1163 23.54C70.4896 23.54 69.2763 23.8733 68.4763 24.54C67.6763 25.2067 67.2763 26.0667 67.2763 27.12C67.2763 28.0267 67.5029 28.7467 67.9563 29.28C68.4229 29.8 69.1429 30.2 70.1163 30.48L72.3163 31.08C74.1029 31.56 75.3763 32.28 76.1363 33.24C76.8963 34.2 77.2763 35.4733 77.2763 37.06C77.2763 38.3667 76.9763 39.5 76.3763 40.46C75.7896 41.4067 74.9363 42.1333 73.8163 42.64C72.7096 43.1333 71.3829 43.38 69.8363 43.38ZM80.8525 43V21.3H83.8925V43H80.8525ZM82.3725 16.6C81.6925 16.6 81.1592 16.42 80.7725 16.06C80.3992 15.7 80.2125 15.2067 80.2125 14.58C80.2125 13.9533 80.3992 13.46 80.7725 13.1C81.1592 12.7267 81.6925 12.54 82.3725 12.54C83.0525 12.54 83.5792 12.7267 83.9525 13.1C84.3258 13.46 84.5125 13.9533 84.5125 14.58C84.5125 15.2067 84.3258 15.7 83.9525 16.06C83.5792 16.42 83.0525 16.6 82.3725 16.6ZM93.1175 43.38C91.3708 43.38 89.7175 43.1067 88.1575 42.56V39.98C89.9175 40.54 91.5575 40.82 93.0775 40.82C94.5842 40.82 95.7308 40.5067 96.5175 39.88C97.3042 39.24 97.6975 38.3333 97.6975 37.16C97.6975 36.16 97.4575 35.3933 96.9775 34.86C96.4975 34.3133 95.7575 33.9 94.7575 33.62L92.5575 33.04C90.8508 32.5733 89.6108 31.8667 88.8375 30.92C88.0775 29.96 87.6975 28.7067 87.6975 27.16C87.6975 25.9467 87.9908 24.8733 88.5775 23.94C89.1642 23.0067 90.0242 22.28 91.1575 21.76C92.3042 21.2267 93.6775 20.96 95.2775 20.96C96.7308 20.96 98.1375 21.12 99.4975 21.44V24.04C98.7775 23.8667 98.0975 23.74 97.4575 23.66C96.8175 23.58 96.1308 23.54 95.3975 23.54C93.7708 23.54 92.5575 23.8733 91.7575 24.54C90.9575 25.2067 90.5575 26.0667 90.5575 27.12C90.5575 28.0267 90.7842 28.7467 91.2375 29.28C91.7042 29.8 92.4242 30.2 93.3975 30.48L95.5975 31.08C97.3842 31.56 98.6575 32.28 99.4175 33.24C100.178 34.2 100.558 35.4733 100.558 37.06C100.558 38.3667 100.258 39.5 99.6575 40.46C99.0708 41.4067 98.2175 42.1333 97.0975 42.64C95.9908 43.1333 94.6642 43.38 93.1175 43.38ZM111.838 40.66C112.492 40.66 113.225 40.5667 114.038 40.38V43.04C113.025 43.2667 112.085 43.38 111.218 43.38C109.232 43.38 107.712 42.8467 106.658 41.78C105.605 40.7 105.078 38.9933 105.078 36.66V23.82H101.398V21.3H105.078L105.578 13.4H108.118V21.3H113.758V23.82H108.118V36.24C108.118 37.3467 108.252 38.22 108.518 38.86C108.785 39.5 109.185 39.96 109.718 40.24C110.265 40.52 110.972 40.66 111.838 40.66ZM116.829 21.3H119.369L119.629 24.26H119.829C120.442 23.2067 121.222 22.4133 122.169 21.88C123.129 21.3467 124.176 21.08 125.309 21.08C125.616 21.08 126.022 21.1133 126.529 21.18V24.08C126.209 24.0267 125.742 24 125.129 24C124.076 24 123.062 24.28 122.089 24.84C121.129 25.4 120.389 26.1733 119.869 27.16V43H116.829V21.3ZM142.761 33.2H130.901C130.941 35.1067 131.188 36.6133 131.641 37.72C132.095 38.8267 132.768 39.62 133.661 40.1C134.555 40.5667 135.715 40.8 137.141 40.8C138.421 40.8 139.961 40.5333 141.761 40V42.6C140.868 42.88 140.028 43.08 139.241 43.2C138.455 43.32 137.648 43.38 136.821 43.38C134.755 43.38 133.061 43.0133 131.741 42.28C130.421 41.5333 129.428 40.3333 128.761 38.68C128.108 37.0267 127.781 34.84 127.781 32.12C127.781 28.2933 128.461 25.48 129.821 23.68C131.181 21.8667 133.075 20.96 135.501 20.96C137.861 20.96 139.661 21.8533 140.901 23.64C142.141 25.4267 142.761 28.2733 142.761 32.18V33.2ZM135.481 23.24C134.055 23.24 132.941 23.82 132.141 24.98C131.355 26.1267 130.941 28.14 130.901 31.02H139.801C139.775 29.0467 139.581 27.4867 139.221 26.34C138.875 25.1933 138.388 24.3933 137.761 23.94C137.148 23.4733 136.388 23.24 135.481 23.24ZM160.535 33.2H148.675C148.715 35.1067 148.961 36.6133 149.415 37.72C149.868 38.8267 150.541 39.62 151.435 40.1C152.328 40.5667 153.488 40.8 154.915 40.8C156.195 40.8 157.735 40.5333 159.535 40V42.6C158.641 42.88 157.801 43.08 157.015 43.2C156.228 43.32 155.421 43.38 154.595 43.38C152.528 43.38 150.835 43.0133 149.515 42.28C148.195 41.5333 147.201 40.3333 146.535 38.68C145.881 37.0267 145.555 34.84 145.555 32.12C145.555 28.2933 146.235 25.48 147.595 23.68C148.955 21.8667 150.848 20.96 153.275 20.96C155.635 20.96 157.435 21.8533 158.675 23.64C159.915 25.4267 160.535 28.2733 160.535 32.18V33.2ZM153.255 23.24C151.828 23.24 150.715 23.82 149.915 24.98C149.128 26.1267 148.715 28.14 148.675 31.02H157.575C157.548 29.0467 157.355 27.4867 156.995 26.34C156.648 25.1933 156.161 24.3933 155.535 23.94C154.921 23.4733 154.161 23.24 153.255 23.24Z",
    fill: "#235B22"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.9518 14.3967L24.6208 1.05518H16.8829L3.51733 43.2621H13.8932C12.6035 40.0379 11.0166 30.8543 16.0035 29.5606C22.1587 27.9638 24.6208 29.8966 32.3587 24.0931C28.6656 29.0172 14.9484 29.1931 14.9484 29.8966L18.9932 15.4759H23.5656L24.6208 18.5926M19.7127 27.9638C20.5028 24.3275 22.2121 21.0952 24.6208 18.5926M17.4104 33.4138C38.8656 39.9207 37.4587 24.0931 46.9553 15.4759C37.7881 11.309 29.6687 13.348 24.6208 18.5926",
    stroke: "#235B22",
    strokeWidth: 0.351724
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_204_347)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.51733 43.2621L16.8829 1.05518H24.6208L30.9518 14.3967C28.5239 15.3185 26.3848 16.7599 24.6208 18.5926L23.5656 15.4759H18.9932L15.3001 29.7207C11.0794 32.6752 12.6035 40.0379 13.8932 43.2621H3.51733Z",
    fill: "#49C93E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.9518 14.3967L24.6208 1.05518H16.8829L3.51733 43.2621H13.8932C12.6035 40.0379 11.0794 32.6752 15.3001 29.7207L18.9932 15.4759H23.5656L24.6208 18.5926M19.7127 27.9638C20.5028 24.3275 22.2121 21.0952 24.6208 18.5926M46.9553 15.4759C37.7881 11.309 29.6687 13.348 24.6208 18.5926",
    stroke: "#235B22",
    strokeWidth: 0.351724
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_204_347)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M46.9552 42.5585L38.9679 28.8413C37.2828 32.3586 33.5897 34.6448 32.3586 34.8206L37.5789 42.5585H46.9552Z",
    fill: "#49C93E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.9552 42.5585L38.9679 28.8413C37.2828 32.3586 33.5897 34.6448 32.3586 34.8206L37.5789 42.5585H46.9552Z",
    stroke: "#235B22",
    strokeWidth: 0.351724
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5368 28.0821C20.3269 24.4459 22.0362 21.2135 24.4449 18.711C29.4928 13.4664 37.6122 11.4273 46.7794 15.5942C37.2828 24.2114 38.8656 39.9209 17.4104 33.414",
    stroke: "#235B22",
    strokeWidth: 0.351724
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_f_204_347)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.9276 26.9071C21.9828 22.6918 23.579 20.4002 25.8518 17.938C30.0725 13.3656 37.8104 11.0794 46.6035 14.9484C38.5139 23.214 38.6604 38.4419 18.9932 32.5347",
    stroke: "#49C93E",
    strokeWidth: 0.351724
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_f_204_347)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.8226 26.8525C22.7904 23.0894 24.2545 21.0435 26.339 18.8454C30.2103 14.7634 37.3075 12.7224 45.3725 16.1764C37.9527 23.5555 38.0871 37.1502 20.0483 31.8765",
    stroke: "#49C93E",
    strokeWidth: 0.351724
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_f_204_347)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.7921 27.3216C21.7733 23.4165 23.2577 21.2934 25.3712 19.0124C29.2962 14.7764 36.492 12.6583 44.669 16.2427C37.1462 23.9002 37.2824 38.0079 18.9932 32.5352",
    stroke: "#49C93E",
    strokeWidth: 0.351724
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter5_f_204_347)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.6935 27.6731C21.621 23.981 23.0241 21.9737 25.0218 19.8171C28.7317 15.8122 35.5332 13.8097 43.2621 17.1985C36.1515 24.4383 36.2803 37.7765 18.9932 32.6023",
    stroke: "#49C93E",
    strokeWidth: 0.351724
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter6_f_204_347)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.6501 27.6726C22.5238 24.1934 23.8456 22.302 25.7275 20.2698C29.2223 16.4959 35.6295 14.6089 42.9104 17.8022C36.212 24.6244 36.3333 37.1931 20.0483 32.3174",
    stroke: "#49C93E",
    strokeWidth: 0.351724
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter7_f_204_347)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.5079 26.6168C23.2741 23.5637 24.4331 21.9038 26.0834 20.1205C29.1481 16.8087 34.7667 15.1528 41.1515 17.9551C35.2775 23.9419 35.3839 34.9715 21.1033 30.6929",
    stroke: "#49C93E",
    strokeWidth: 0.351724
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_204_347",
    x: 1.8702,
    y: 0.879395,
    width: 46.5648,
    height: 45.3724,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.4069
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.703448
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.137255 0 0 0 0 0.356863 0 0 0 0 0.133333 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_204_347"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_204_347",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_204_347",
    x: 30.649,
    y: 28.4658,
    width: 18.0189,
    height: 17.0823,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.4069
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.703448
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_204_347"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_204_347",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_204_347",
    x: 16.1288,
    y: 9.99236,
    width: 33.5919,
    height: 26.86,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.4069,
    result: "effect1_foregroundBlur_204_347"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_f_204_347",
    x: 17.537,
    y: 11.783,
    width: 30.6063,
    height: 23.9173,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.23103,
    result: "effect1_foregroundBlur_204_347"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_f_204_347",
    x: 16.8325,
    y: 12.1348,
    width: 30.251,
    height: 23.917,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.05517,
    result: "effect1_foregroundBlur_204_347"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_f_204_347",
    x: 16.8323,
    y: 13.1899,
    width: 28.8442,
    height: 22.8618,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.05517,
    result: "effect1_foregroundBlur_204_347"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_f_204_347",
    x: 17.5357,
    y: 13.5413,
    width: 28.1407,
    height: 22.5101,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.23103,
    result: "effect1_foregroundBlur_204_347"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter7_f_204_347",
    x: 18.2389,
    y: 13.5412,
    width: 26.0304,
    height: 21.1032,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.4069,
    result: "effect1_foregroundBlur_204_347"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMainLogo);
export default __webpack_public_path__ + "static/media/main-logo.904066344a31bb64f71e732ccc08b7cf.svg";
export { ForwardRef as ReactComponent };